export default "__VITE_ASSET__Bq$NPcuY__"